import { render, staticRenderFns } from "./AuthorWritingFrequency.vue?vue&type=template&id=db339fe6&scoped=true"
import script from "./AuthorWritingFrequency.vue?vue&type=script&lang=js"
export * from "./AuthorWritingFrequency.vue?vue&type=script&lang=js"
import style0 from "./AuthorWritingFrequency.vue?vue&type=style&index=0&id=db339fe6&prod&scoped=true&lang=css"
import style1 from "./AuthorWritingFrequency.vue?vue&type=style&index=1&id=db339fe6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db339fe6",
  null
  
)

export default component.exports